export default "<router-outlet>\n  <app-error-modal [errorCode]=\"errorCode\"></app-error-modal>\n</router-outlet>\n"